<template>
    <div class="row">
        <div class="col-1 text-center">
            <slot name="left"/>
        </div>
        <div class="col-10">
            <h4 class="page-title" v-html="title"/>
        </div>
        <div class="col-1 text-center">
            <slot name="right"/>
        </div>
        <hr class="col-12"/>
    </div>
</template>

<script>
export default {
    name: "PageTitle",
    props: {
        title: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>